function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GridMouseHandler } from '@deephaven/grid';
import deepEqual from 'fast-deep-equal';
/**
 * Handles cursor and click action for cell overflow button
 * The button is rendered via IrisGridRenderer
 */
class IrisGridCellOverflowMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super(850); // Needs to be before GridSelectionMouseHandler
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  destroyColumnTooltip() {
    this.irisGrid.setState({
      overflowButtonTooltipProps: null
    });
  }
  setCursor(point) {
    if (this.isHoveringOverflowButton(point)) {
      this.cursor = 'pointer';
      return {
        stopPropagation: false,
        preventDefault: false
      };
    }
    this.cursor = null;
    return false;
  }
  getButtonPosition(_ref) {
    var x = _ref.x,
      y = _ref.y,
      column = _ref.column,
      row = _ref.row;
    if (column == null || row == null) {
      return null;
    }
    var _this$irisGrid = this.irisGrid,
      renderer = _this$irisGrid.renderer,
      grid = _this$irisGrid.grid,
      state = _this$irisGrid.state,
      props = _this$irisGrid.props;
    if (!grid) {
      return null;
    }
    var metrics = state.metrics;
    var model = props.model;
    var context = grid.canvasContext;
    var theme = this.irisGrid.getTheme();
    var rendererState = {
      context,
      mouseX: x,
      mouseY: y,
      metrics,
      model,
      theme
    };
    var _renderer$getCellOver = renderer.getCellOverflowButtonPosition(rendererState),
      left = _renderer$getCellOver.left,
      top = _renderer$getCellOver.top,
      width = _renderer$getCellOver.width,
      height = _renderer$getCellOver.height;
    if (left == null || width == null || top == null || height == null) {
      return null;
    }
    return {
      left,
      top,
      width,
      height
    };
  }
  isHoveringOverflowButton(point) {
    var _this$getButtonPositi;
    var x = point.x,
      y = point.y;
    var _ref2 = (_this$getButtonPositi = this.getButtonPosition(point)) !== null && _this$getButtonPositi !== void 0 ? _this$getButtonPositi : {},
      left = _ref2.left,
      top = _ref2.top,
      width = _ref2.width,
      height = _ref2.height;
    if (left == null || width == null || top == null || height == null) {
      return false;
    }
    var _this$irisGrid2 = this.irisGrid,
      renderer = _this$irisGrid2.renderer,
      grid = _this$irisGrid2.grid,
      state = _this$irisGrid2.state,
      props = _this$irisGrid2.props;
    if (!grid) {
      return false;
    }
    var metrics = state.metrics;
    var model = props.model;
    var context = grid.canvasContext;
    var theme = grid.getTheme();
    var rendererState = {
      context,
      mouseX: x,
      mouseY: y,
      metrics,
      model,
      theme
    };
    return renderer.shouldRenderOverflowButton(rendererState) && x >= left && x <= left + width && y >= top && y <= top + height;
  }
  onMove(point) {
    if (this.isHoveringOverflowButton(point)) {
      var overflowButtonTooltipProps = this.irisGrid.state.overflowButtonTooltipProps;
      var newProps = this.getButtonPosition(point);
      if (!deepEqual(overflowButtonTooltipProps, newProps)) {
        this.irisGrid.setState({
          overflowButtonTooltipProps: newProps
        });
      }
    } else {
      this.destroyColumnTooltip();
    }
    return this.setCursor(point);
  }
  onWheel(point) {
    this.destroyColumnTooltip();
    return this.onMove(point);
  }

  // Needs to be onDown and not onClick b/c of GridSelectionMouseHandler shifting cell onDown
  onDown(point) {
    this.destroyColumnTooltip();
    var column = point.column,
      row = point.row;
    if (this.isHoveringOverflowButton(point)) {
      this.irisGrid.setState({
        showOverflowModal: true,
        overflowText: this.irisGrid.getValueForCell(column, row)
      });
      return true; // Consume the event so GridSelectionMouseHandler doesn't clear the row selection
    }
    return false;
  }
  onContextMenu() {
    this.destroyColumnTooltip();
    return false;
  }
  onLeave() {
    this.destroyColumnTooltip();
    return false;
  }
}
export default IrisGridCellOverflowMouseHandler;
//# sourceMappingURL=IrisGridCellOverflowMouseHandler.js.map